import makeStyles from "@mui/styles/makeStyles";
import { getBrandCustom } from "Util/getCustomColor";

const styles = makeStyles((theme) => ({
  icon: {
    fontSize: 30,
    margin: "0 5px",
  },
  link: {
    cursor: "pointer",
  },
  title: {
    color: getBrandCustom("primaryColor", "#38CFC4"),
    fontSize: "18px",
    fontFamily: "Inter",
    fontWeight: 600,
    lineHeight: "24px",
  },
}));

export default styles;
